export default {
  namespaced: true,
  state: {
    status: null,   // 'exporting' | 'success' | 'error' | null
    errorMsg: '',
  },
  mutations: {
    SET_STATUS(state, status) {
      state.status = status;
    },
    SET_ERROR(state, msg) {
      state.errorMsg = msg;
    },
    CLEAR(state) {
      state.status = null;
      state.errorMsg = '';
    },
  },
};
